<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header" class="title_head">Create Card
      </div>
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-row>
            <!-- <div class="alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div> -->
            <b-col sm="3">
              <b-form-group>
                <label for="name"> Shop Name </label>
                  <model-list-select  :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="select_shop" placeholder="Select Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                   <small  class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter Ledger No."
                  autocomplete="off"
                  v-model="cardData.ledgerno"
                ></b-form-input> -->
              </b-form-group>
                
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <label for="name"> Scheme </label>
                  <model-list-select @input="onSchemeChange($event)" :list="schemelist" option-value="scheme_id" option-text="scheme_name" v-model="selectedscheme" placeholder="Select Scheme" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                   <small  class="form-text text-muted"><strong style="color: red;">{{haserror.scheme}}</strong></small>
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter Ledger No."
                  autocomplete="off"
                  v-model="cardData.ledgerno"
                ></b-form-input> -->
              </b-form-group>
                
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label for="name"> Monthly Pay </label>
                <b-form-input
                  type="text"
                  placeholder="Monthly Pay"
                  autocomplete="off"
                  v-model="cardData.monthlypay"
                  
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <label for="name"> Opening Month </label>
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter your Opening Month"
                  autocomplete="off"
                  v-model="cardData.openingmonth"
                ></b-form-input> -->
                 <!-- <model-list-select :list="monthlist" option-value="name" :custom-text="monthName" v-model="openingmonth" placeholder="Select Month" @input="onSelectMonth($event)" @searchchange="searchmonths" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select> -->
                 
                   <input type="text" class="form-control" id="cust_name" name="txtCustName" v-model="openingmonth" autocomplete="off" :disabled=true>
              </b-form-group>
              <small  class="form-text text-muted"><strong style="color: red;">{{haserror.month}}</strong></small>
            </b-col>
             <b-col sm="4">
               
              <b-form-group>
                <label for="name"> Customer Name </label>
                <input type="text" class="form-control" id="cust_name" name="txtCustName" v-model="selectedcustomer" autocomplete="off" :disabled=true>
                 <!-- <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="selectedcustomer" placeholder="Search Customer Name" @input="onSelectCust($event)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select> -->
                 <!-- <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="cardData.customername" placeholder="Search Customer Name" @input="onSelectCust($event)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select> -->
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter your Customer Name"
                  autocomplete="off"
                  v-model="cardData.customername"
                ></b-form-input> -->
                
              </b-form-group>
              <small  class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="name"> Address </label>
                <b-form-input
                  type="text"
                  placeholder="Address"
                  autocomplete="off"
                  v-model="cardData.address"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row> 
          <b-row>
          <b-col sm="12">
            <b-button-group>
              <b-button class="d-sm-down-none btn-sm" @click.prevent="cardEdit()" variant="primary"><i class="fa fa-dot-circle-o"></i> Edit</b-button>
            </b-button-group>
          </b-col>
        </b-row>
          <!-- <div>
            <vue-good-table
            :columns="columns"
            :rows="rows"/>
            </div>   -->      
        </b-card-body> 
      </b-collapse>
    </b-card>

    <Spinner v-if="loading"></Spinner>
  </div>


</template>


<style>
.switch.switch-text .switch-label::before,
.switch.switch-text .switch-label::after {
  width: 67% !important;
}
.switch.switch-text {
  width: 74px;
}
.switch.switch-text .switch-input:checked ~ .switch-handle {
  left: 50px;
}
.switch.switch-text .switch-label {
  background-color: red;
}
.selected_row {
  background-color: blue;
}
.modal-title {
  color: black;
  font-weight: bold;
}
</style>

<script>
export default {
  name: 'my-component',
  data(){
    return {
       customername:[],
       monthlist:[],
       shopname:[],
       schemelist:[],
       selectedcustomer:null,
       openingmonth:null,
       loading:false,
       select_shop:null,
       selectedscheme:null,
       haserror:{
          month:'',
          shop:'',
          cust:'',
          scheme:'',
          message:'',
          inclusive:'',
          shop:''
        },
      columns: [
        {
          label: 'month',
          field: 'month',
        },
        {
          label: 'paymonthly',
          field: 'paymonthly',
          type: 'number',
        },
        {
          label: 'Date',
          field: 'Date',
        },
      ],
         cardData:{
                    ledgerno:'',
                    monthlypay:'',
                    address:'',
                    message:'',

                }        
    };
  },
  created(){
    this.searchcustomer();
    this.searchscheme();
    this.searchshops();
    this.searchmonths();
     this.edit_card_data();
  },
  methods:{
    searchmonths(){
       var _this = this
          var myObj =[
	{
		"abbreviation": "Jan",
		"name": "January"
	},
	{
		"abbreviation": "Feb",
		"name": "February"
	},
	{
		"abbreviation": "Mar",
		"name": "March"
	},
	{
		"abbreviation": "Apr",
		"name": "April"
	},
	{
		"abbreviation": "May",
		"name": "May"
	},
	{
		"abbreviation": "Jun",
		"name": "June"
	},
	{
		"abbreviation": "Jul",
		"name": "July"
	},
	{
		"abbreviation": "Aug",
		"name": "August"
	},
	{
		"abbreviation": "Sep",
		"name": "September"
	},
	{
		"abbreviation": "Oct",
		"name": "October"
	},
	{
		"abbreviation": "Nov",
		"name": "November"
	},
	{
		"abbreviation": "Dec",
		"name": "December"
	}
];
_this.monthlist= myObj
        },
    searchcustomer(){
        var _this = this
        this.$http.get('/api/customers').then(function (response) {
          _this.customername = response.data
        }).catch(function (error) {
        });
      },
      searchscheme(){
        var _this = this
        this.$http.get('/api/goldschemes').then(function (response) {
          _this.schemelist = response.data
        }).catch(function (error) {
        });
      },
      onSchemeChange(option){
        this.haserror.scheme = ''
        this.cardData.monthlypay = option.monthly_pay
      },
      nameAndnumber (item) {
        return `${item.cust_cmp_name} - ${item.cust_cmp_phone}`
      },
      monthName(item)
      {
          return `${item.name}`
      },
      // nameAndnumber1 (item) {
      //   return `${item.name} - ${item.name}`
      // },
      onSelectCust(option1){
         this.haserror.cust = ''
         console.log(option1)
        this.cardData.address=option1.address1
      },
       onSelectMonth(option1){
          this.haserror.month = ''
      },
      searchshops(shop_id){
        var _this = this
        this.$http.get('/api/shopusers/getShop').then(function (response) {
          _this.shopname = response.data
          if(shop_id === undefined){
            for (var i = 0; i < response.data.length; i++) {
              if(response.data.length == i+1){
                _this.selectshop = response.data[i]
                if(_this.selectshop.saleprice === true){
                  _this.saleprice_editable = true
                  _this.saleprice_nonedit = false
                }
                else{
                  _this.saleprice_nonedit = true
                  _this.saleprice_editable = false
                }
                _this.company_data();
              }
            }
          }
          else{
            var select_shp = _this.shopname.filter(function(each){
              return each.est_shop_id === shop_id
            });
            _this.selectshop = select_shp[0]
            if(_this.selectshop.saleprice === true){
              _this.saleprice_editable = true
              _this.saleprice_nonedit = false
            }
            else{
              _this.saleprice_nonedit = true
              _this.saleprice_editable = false
            }
            _this.company_data();
          }
        }).catch(function(er){
          console.log(er)
        })
      },
      edit_card_data(){
            this.card_id = JSON.parse(localStorage.getItem('card_id'));
         var _this = this;
      //this.temprow = row;
      // var data =[]
      var data = "&filter[where][card_id]=" + this.card_id;
     
      this.$http
        .get(
          "/api/customercards/searchdb?params=" +data
        )
        .then(function (response) {
          if (response.data != undefined) {
            _this.totalRecords1 = response.data[0].totalRecords;
            response.data.shift();
           // _this.rows1 = response.data; 
           console.log(response.data[0].customer_id)
           // _this.selectedcustomer = response.data[0].customer_id
           _this.cardData.address = response.data[0].address1
           _this.cardData.monthlypay = response.data[0].monthly_pay
           _this.selectedcustomer = response.data[0].cust_cmp_name
           _this.selectedscheme = response.data[0]
           _this.select_shop = response.data[0]
           _this.openingmonth = response.data[0].opening_month
            
          
            //_this.show_card_entry();
          
            
          }
        });
      },
      cardEdit(){ 
        var _this = this
        this.haserror.message=''
        
        this.submit_true=0;
        //this.onComplete('check')
        // var formData = new FormData();
        // _this.hasErrors.brandlogo=false;
        // const fileInput = document.querySelector('#image');
      if (this.submit_true==0){
          this.loading=true
          //this.largeModal=false;
           if(this.select_shop==null || this.select_shop.est_shop_id === undefined){
              _this.loading=false;
            this.haserror.shop="Please Select Shop"
          }else if(_this.selectedscheme==null || _this.selectedscheme.scheme_id === undefined){
               _this.loading=false;
              _this.haserror.scheme="Please Select Scheme"
              }else{
                 var user=null;
          _this.submitcardvalue(_this)
              }
         
             }
          },
            submitcardvalue(_this){
              
                      let res = {
                         
                          monthly_pay:this.cardData.monthlypay,
                        //   customer_id:this.selectedcustomer.customer_id,
                        //   cust_address:this.cardData.address,
                          est_shop_id:this.select_shop.est_shop_id,
                          scheme_id : this.selectedscheme.scheme_id,
                         
                        }

                this.$http.post('/api/customercards/update?where[card_id]='+this.card_id, res)
                .then(function (response) {
              
              
               if(response.status==200){
                _this.message = true
                 _this.message = "Card Edited Successfully"
                 alert("Card Edited Successfully")
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                  _this.$router.push("/cardlist");
                // _this.getTotals();
                  _this.reset();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },
            
  }
};
</script>



// WEBPACK FOOTER //
// src/views/gold/editcard.vue